<template>
  <v-container fluid grid-list-md ma-0 pa-0>
    <v-layout row wrap>
      <v-flex pa-4 xs12 sm6 md4 lg4 xl4 v-for="card in webJson" :key="card.id">
        <v-card
          :to="{
            name: 'service-template-details',
            params: { web: card },
            query: {
              id: card.id,
              name: card.name,
              serviceType: card.serviceType
            }
          }"
        >
          <v-responsive>
            <v-img :src="card.imgUrl" :srcset="card.altImg" height="300px">
            </v-img>
          </v-responsive>
          <v-card-title>
            <v-container fill-height fluid pa-2>
              <v-layout fill-height>
                <v-flex xs10 align-end flexbox>
                  <span class="font-regular caption">Name: </span>
                  <span class="font-regular caption" v-text="card.name"></span>
                  <v-divider></v-divider>
                  <span class="font-regular caption">Service Type: </span>
                  <span
                    class="font-regular caption"
                    v-text="card.serviceType"
                  ></span>
                  <v-divider></v-divider>
                  <span class="font-regular caption">Tags: </span>
                  <span class="font-regular caption" v-text="card.tags"></span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>

          <v-card-actions>
            <v-flex class="text-center">
              <v-btn
                color="primary"
                block
                target="_blank"
                :to="{
                  name: 'service-template-details',
                  params: { web: card },
                  query: {
                    id: card.id,
                    name: card.name,
                    serviceType: card.serviceType
                  }
                }"
              >
                Explore
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-layout align-center justify-center v-if="isMore">
        <v-btn rounded color="primary" @click="scroll()">
          Show me more
        </v-btn>
      </v-layout>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "ServRender",
  data: () => ({
    isAuthenticated: false,
    isMore: true,
    total: 1,
    pageIndex: 0,
    webJson: []
  }),
  props: ["cards", "index"],
  mounted() {
    if (this.$store.state.userId != "") {
      this.isAuthenticated = true;
    }
    this.pageIndex = this.index;
    this.scroll();
  },
  methods: {
    scroll() {
      this.total = this.cards.length;
      var limit = this.pageIndex + 30;
      var i = 0;
      for (i = this.pageIndex; i < limit && i < this.total; i++) {
        this.webJson.push(this.cards[i]);
      }
      this.pageIndex = i;
      if (this.pageIndex === this.total) this.isMore = false;
    }
  }
};
</script>

<style>
.rounded {
  border-radius: 50px;
  border-color: primary;
}
</style>
